import SectionModel from "../../models/sectionModel.js";
import {
    CONTROL_TYPE,
    CUSTOMER_SERVICE_MODEL,
    DELIVERY_STRATEGY,
    DELIVERY_TYPE,
    deliveryTypes,
    FILTER_TYPE,
    filterCustomerCustomersTypes,
    filterCustomerOrdersTypes,
    filterUnfinishedCartTypes,
    getAccountOrderDeliveryStrategyList,
    getLoyaltyLevel,
    getOrderChannelNames,
    getOrderStatusLabelText,
    getRatingList,
    GLOBAL_FILTER_TYPE,
    loyaltyLevels,
    ORDER_STATE,
    orderChannelNames,
    orderStatusLabelTexts,
    ReportType,
    TYPE_ACTION,
} from "../../utils/enums.js";
import React, { useState } from "react";
import CustomerSales from "../../app/components/CustomerSales/index.js";
import { CustomerServiceChat } from "../../app/components/CustomerServiceChat/CustomerServiceChat.jsx";
import IconButton from "../../app/components/IconButton/IconButton.jsx";
import { Tooltip } from "antd";
import i18n from "../../i18n.js";
import { DATE_FORMAT, DATE_TIME_FORMAT, getFormattedDate, isDefaultDate, setEndTime, setStartTime } from "../../utils/convertTime.js";
import { getDepotNameByBusinessId, getAllProviders, getDepotNameById, getDepots, getTerritoriesEntity, getTerritoryNameByEntityId } from "../restaurant.js";
import { currentUserIsDepotRole, getCurrentLanguage } from "../userModel.js";
import { groupBarOrderFilter } from "../filter.js";
import FilterOptionsModel from "../../models/filterOptionsModel.js";
import moment from "moment";
import { SummaryCustomerCustomersFilter, SummaryCustomerOrdersFilter, SummaryCustomerReviewFilter, SummaryUnfinishedCartFilter } from "../../app/components/SummaryOrderFilter/SummaryOrderFilter.jsx";
import { AddCallCenterOrderButton, AddCustomerButton } from "../../app/components/TableAddButton/index.js";
import { LOAD_HISTORY_CUSTOMERS_CUSTOMERS_PAGE, LOAD_HISTORY_CUSTOMERS_ORDERS_PAGE, LOAD_HISTORY_CUSTOMERS_REVIEWS_PAGE, LOAD_UNFINISHED_CART_PAGE } from "../../store/reducers/order/order-actions.js";
import CustromerServiceOrders from "../../app/components/CustomerServiceOrders/CustromerServiceOrders.jsx";
import { getCardMasksForOrder, getOrderSource } from "../../utils/order.js";
import { getComplaintCategoryOptions, getComplaintCategoryTitles } from "../complaintCategories.js";
import { useHistory } from "react-router";
import ExportFileControl from "../../app/components/ExportFileControl/ExportFileControl.jsx";
import { CUSTOMER_REVIEWS_GET_REPORT, CUSTOMERS_GET_REPORT } from "../../store/reducers/customer/customer-actions.js";
import ReportModalDateRange from "../../app/components/ReportModalDateRange/ReportModalDateRange.jsx";
import OrdersPageWrapper from "../../app/components/SectionOrdersPageWrapper/OrdersPageWrapper.jsx";
import UnfinishedCartPreview from "../../app/components/UnfinishedCartPreview/UnfinishedCartPreview.jsx";
import { GET_CALLCENTER_ORDERS_PROVIDER } from "../../store/reducers/restaurant/restaurant-actions.js";
import TimeBox from "../../app/components/TimeBox/TimeBox.jsx";

const renderTextComponent = (text, trimTo, neverRtl) => {
    if (!text) return "";
    const shortText = text.length > (trimTo || 20) ? `${text.slice(0, (trimTo || 20))?.trim()}...` : text;
    return (
        <Tooltip styles={{ body: { textAlign: i18n.language === "he" ? "right" : "left"} }} title={text}>
            <span style={neverRtl ? {direction: 'ltr', display: 'inline-block'} : {}} >{shortText}</span>
        </Tooltip>
    );
}

export function createCustomerServiceOrderSection() {
    const lang = getCurrentLanguage();

    return new SectionModel({
        filterOptions: createOrdersSectionFilter(),
        columns: [
            {
                accessor: 'deliveryMethod',
                title: i18n.t('orders.tableColumns.TYPE'),
                width: 200,
                search: true,
                type: 'lookup',
                lookupOptions: () => deliveryTypes().concat({ key: DELIVERY_TYPE.virtualVenue, value: i18n.t('dashboard.orders.VIRTUAL_VENUE_ORDERS_MODE_LABEL') }),
                component: (_, item) => {
                    const icons = {
                        [DELIVERY_TYPE.dinein]: 'dinein',
                        [DELIVERY_TYPE.delivery]: 'carbonScooter',
                        [DELIVERY_TYPE.takeAway]: 'carbonTakeaway',
                        [DELIVERY_TYPE.virtualVenue]: 'virtualVenueGift',
                    }
                    const typeIcon = icons[item.delivery_type];
                    return <IconButton isIcon iconName={typeIcon} />;
                },
                canHideColumn: true,
            },
            {
                accessor: 'creationDateTime',
                title: i18n.t('orders.tableColumns.DATE'),
                hideFilterFromPreview: true,
                alwaysOnFilter: true,
                search: true,
                enableSortColumn: true,
                width: 205,
                component: (_, item) => isDefaultDate(item.creation_datetime) ? '' : getFormattedDate(item.creation_datetime, DATE_TIME_FORMAT),
                canHideColumn: true,
                shortFilter: true,
                type: 'date',
            },
            {
                accessor: 'deliveryDateTime',
                title: i18n.t('admin-orders.DELIVERY_INFO_DATE_TIME_LABEL'),
                search: true,
                enableSortColumn: true,
                width: 205,
                component: (_, item) => isDefaultDate(item.delivery_datetime) ? '' : getFormattedDate(item.delivery_datetime, DATE_TIME_FORMAT),
                canHideColumn: true,
                type: 'date',
            },
            {
                accessor: 'actualDeliveryTime',
                title: i18n.t('admin-orders.DELIVERY_INFO_ACTUAL_DATE_TIME_LABEL'),
                search: true,
                enableSortColumn: true,
                width: 205,
                component: (_, item) => isDefaultDate(item.actual_delivery_datetime) ? '' : getFormattedDate(item.actual_delivery_datetime, DATE_TIME_FORMAT),
                canHideColumn: true,
                type: 'date',
            },
            {
                accessor: 'sequenceId',
                title: i18n.t('admin-orders.ORDER_INFO_NUMBER_LABEL'),
                width: 150,
                search: true,
                canHideColumn: true,
                type: 'number',
                filterPlaceholder: i18n.t('admin-orders.ORDER_INFO_NUMBER_LABEL'),
                component: (_, item) => renderTextComponent(item?.sequence_id),
            },
            {
                accessor: 'phone',
                title: i18n.t('orders.tableColumns.PHONE'),
                width: lang === 'ru' ? 160 : 150,
                search: true,
                canHideColumn: true,
                type: 'string',
                filterPlaceholder: i18n.t('orders.CENTER_PHONE_FILTER_LABEL'),
                component: (_, item) => renderTextComponent(item?.phone, 15),
            },
            {
                accessor: 'status',
                title: i18n.t('orders.tableColumns.STATUS'),
                width: 200,
                search: true,
                component: (_, item) => {
                    const showRelatedTime = item.status === ORDER_STATE.new ? <span className="relativeTime"><TimeBox date={item.creation_datetime} /></span> : null;
                    return (
                        <div className="statusContainer">
                            <div className={`statusBlock statusBlock__${item?.status}`}>
                                {getOrderStatusLabelText(item?.status, item.delivery_type -1)}
                            </div>
                            {showRelatedTime && (
                                <div className="relativeTimeContainer">
                                    {i18n.t("admin-orders.CREATION_DATE_TIME_AGO_LABEL")}
                                    {showRelatedTime}
                                </div>
                            )}
                        </div>
                    )
                },
                canHideColumn: true,
                type: 'lookup',
                lookupOptions: orderStatusLabelTexts,
            },
            {
                accessor: 'orderChannel',
                title: i18n.t('admin-orders.ORDER_CHANNEL'),
                search: true,
                width: 205,
                canHideColumn: true,
                type: 'lookup',
                lookupOptions: getOrderChannelNames,
                component: (_, item) => {
                    return renderTextComponent(orderChannelNames()[item.order_channel]);
                },
            },
            {
                accessor: 'orderSource',
                title: i18n.t('dashboard.orders.ORDER_ORDER_SOURCE_GROUP_LABEL'),
                search: true,
                width: 205,
                canHideColumn: true,
                type: 'lookup',
                lookupOptions: getAllProviders,
                component: (_, item) => {
                    return renderTextComponent(getOrderSource(item.order_source, item.order_source_id));
                },
            },
            {
                accessor: 'depotId',
                title: i18n.t('orders.tableColumns.DEPOT'),
                search: true,
                width: 205,
                canHideColumn: true,
                enableSortColumn: true,
                type: 'lookup',
                maxLookupQuantity: 10,
                hideSelectAll: true,
                lookupOptions: () => getDepots(false).map(d => ({ value: d.name, key: d.id })),
                component: (_, item) => {
                    return renderTextComponent(getDepotNameById(item?.depot_id));
                },
            },
            {
                accessor: 'deliveryStrategy',
                title: i18n.t('orders.tableColumns.DELIVERY_STRATEGY'),
                width: lang === 'ru' ? 250 : 215,
                canHideColumn: true,
                search: true,
                type: 'lookup',
                lookupOptions: () => [
                    { key: DELIVERY_STRATEGY.asap, value: i18n.t('enums.accountOrderDeliveryStrategy.ASAP') },
                    { key: DELIVERY_STRATEGY.concreteTime, value: i18n.t('enums.accountOrderDeliveryStrategy.CONCRETETIME') },
                ],
                component: (value, item) => getAccountOrderDeliveryStrategyList(item.delivery_strategy),
            },
            // Multi-city accounts only — a single-territory account has nothing to show here, and the
            // column set is built per account on every call anyway. The order's own entity_id IS the
            // city account, so the same accessor both names the territory and filters by it
            // (filterCustomerOrdersTypes.entityId → FieldType.EntityId → AccountOrderDTO.EntityId).
            ...(getTerritoriesEntity().length ? [{
                accessor: 'entityId',
                title: i18n.t('dashboard.orders.ORDER_DELIVERY_TERRITORY_LABEL'),
                width: 205,
                canHideColumn: true,
                search: true,
                type: 'lookup',
                lookupOptions: () => getTerritoriesEntity().map(t => ({ key: t.entityId, value: t.name })),
                component: (_, item) => renderTextComponent(getTerritoryNameByEntityId(item?.entity_id)),
            }] : []),
            {
                accessor: 'city',
                title: i18n.t('orders.tableColumns.ADDRESS_CITY'),
                width: 205,
                canHideColumn: true,
                search: true,
                type: 'string',
                component: (_, item) => renderTextComponent(item?.city),
            },
            {
                accessor: 'cardMask',
                title: i18n.t('admin-orders.ADMIN_ORDERS_SEARCH_CARD_MASK_LABEL'),
                width: 205,
                canHideColumn: true,
                search: true,
                type: 'string',
                component: (_, item) => renderTextComponent(getCardMasksForOrder(item.payments), 20, true),
            },
            {
                accessor: 'paymentBalance',
                title: i18n.t('uilib.summary.PAYMENT_BALANCE'),
                width: 200,
                search: true,
                canHideColumn: true,
                component: (amount, item) => item.payment_balance,
                type: 'number',
            },
            {
                accessor: 'deliveryPrice',
                title: i18n.t('admin-orders.ORDER_SUMMARY_DELIVERY_FEE_LABEL'),
                width: 200,
                search: true,
                canHideColumn: true,
                component: (amount, item) => item.delivery_price,
                type: 'number',
            },
            {
                accessor: 'price',
                title: i18n.t('admin-orders.ORDER_SUMMARY_TOTAL_LABEL'),
                width: 200,
                search: true,
                canHideColumn: true,
                component: (amount, item) => amount,
                type: 'number',
            },
            {
                accessor: 'topUpToMinimum',
                title: i18n.t('admin-orders.ORDER_SUMMARY_TOPUP_TO_MINIMUM'),
                width: 200,
                search: true,
                canHideColumn: true,
                component: (amount, item) => item.topup_to_minimum,
                type: 'number',
            },
            {
                accessor: 'fullPrice',
                title: i18n.t('admin-orders.ORDER_SUMMARY_AMOUNT_LABEL'),
                width: 200,
                search: true,
                canHideColumn: true,
                component: (amount, item) => item.full_price,
                type: 'number',
            },
            {
                accessor: 'discount',
                title: i18n.t('pending-orders.PENDING_ORDER_INFO_DISCOUNT'),
                width: 200,
                search: true,
                canHideColumn: true,
                component: (amount, item) => amount,
                type: 'number',
            },
            {
                accessor: 'loyaltyLevel',
                title: i18n.t('settings.loyaltyCashback.LOYALTY_LEVEL'),
                width: lang === 'ru' ? 250 : 215,
                canHideColumn: true,
                search: true,
                type: 'lookup',
                lookupOptions: () => loyaltyLevels(),
                component: (value, item) => getLoyaltyLevel(item.loyalty_level, true),
            },
            {
                accessor: 'id',
                title: i18n.t('orders.tableColumns.ORDER_ID'),
                keyFromSearch: 'searchStr',
                alwaysHidden: true,
                visible: false,
                canHideColumn: true,
                formatForPreview: (items, filter) => {
                    const order = (items || []).find(order => order.id === filter.value);
                    return {
                        columnTitle: order ? getDepotNameById(order.depot_id) : null,
                        operator: order ? '/' : null,
                        value: order ? order.sequence_id : null,
                    }
                },
                component: (amount, item) => amount,
                width: 200,
                type: 'string',
            },
            {
                accessor: 'customerId',
                title: i18n.t('orders.tableColumns.ORDER_ID'),
                alwaysHidden: true,
                visible: false,
                canHideColumn: true,
                alwaysOnFilter: true,
                hideFilterFromPreview: true,
                component: (amount, item) => amount,
                width: 200,
                type: 'string',
            },
        ],
        isForceUpdate: true,
        customTableConfig: {
            key: 'customerService',
            factoryMap: filterCustomerOrdersTypes,
            mainDateKey: 'creationDateTime',
            summaryComponent: SummaryCustomerOrdersFilter,
            addComponent: AddCallCenterOrderButton,
            filterType: GLOBAL_FILTER_TYPE.customerOrders,
            loadDataAction: LOAD_HISTORY_CUSTOMERS_ORDERS_PAGE,
            defaultFilters: {
                status: { operator: "is", type: "lookup", value: [{ key: ORDER_STATE.new, value: i18n.t('orders.PENDING_STATUS_LABEL') }], value2: "" },
            },
            popupComponent: (props) => <CustromerServiceOrders closeIcon {...props} />,
            hideDefaultCloseIcon: false,
            closeButtonInChild: true,
            pinnablePopup: true,
            resetFiltersButton: true,
        },
        actionLoad: GET_CALLCENTER_ORDERS_PROVIDER,
        typeAction: TYPE_ACTION.edit,
        customSettings: 'adminOrderFixed',
        initNewItemModel: () => ({}),
        typeModel: CUSTOMER_SERVICE_MODEL.order,
        isHideControls: true,
        mappingLambda: state => ({}),
    });
}

const ReviewItemCustomer = ({ value }) => {
    const history = useHistory();

    const handleOnCustomerClick = () => {
        if (value.customer_id && !currentUserIsDepotRole()) {
            history.push(`${CUSTOMER_SERVICE_MODEL.customers}?userId=${value.customer_id}`);
        }
    }

    return (<div className="reviewClickableItem" onClick={handleOnCustomerClick}>
        {value.customer_name}
    </div>);
}

const ReviewItemOrderId = ({ value }) => {
    const history = useHistory();

    const handleOnOrderClick = () => {
        if (value.id) history.push(`${CUSTOMER_SERVICE_MODEL.order}?searchStr=${value.id}`);
    }

    return (<div className="reviewClickableItem" onClick={handleOnOrderClick}>
        {value.sequence_id}
    </div>);
}

export function createCustomerServiceReviewsSection() {
    return new SectionModel({
        filterOptions: createOrdersSectionFilter(),
        columns: [
            {
                accessor: 'creationDateTime',
                title: i18n.t('orders.tableColumns.DATE'),
                search: true,
                enableSortColumn: true,
                width: 205,
                component: (_, item) => isDefaultDate(item?.creation_datetime) ? '' : getFormattedDate(item?.creation_datetime, DATE_TIME_FORMAT),
                canHideColumn: true,
                alwaysOnFilter: true,
                hideFilterFromPreview: true,
                shortFilter: true,
                type: 'date',
            },
            {
                accessor: 'sequenceId',
                title: i18n.t('admin-orders.ORDER_INFO_NUMBER_LABEL'),
                width: 120,
                search: true,
                canHideColumn: true,
                component: (amount, item) => <ReviewItemOrderId value={item} />,
                type: 'number',
            },
            {
                accessor: 'deliveryRating',
                title: i18n.t('reviews.REVIEW_FILTER_RATE_DELIVERY'),
                width: 200,
                search: true,
                canHideColumn: true,
                component: (amount, item) => item.delivery_rating ? `${item.delivery_rating} ⭐` : '',
                type: 'lookup',
                lookupOptions: getRatingList,
            },
            {
                accessor: 'rating',
                title: i18n.t('reviews.REVIEW_FILTER_RATE_PRODUCT'),
                width: 200,
                search: true,
                canHideColumn: true,
                component: (amount, item) => item.rating ? `${item.rating} ⭐` : '',
                type: 'lookup',
                lookupOptions: getRatingList,
            },
            {
                accessor: 'userName',
                title: i18n.t('reviews.REVIEW_USER_NAME'),
                width: 200,
                canHideColumn: true,
                component: (amount, item) => <ReviewItemCustomer value={item} />,
                type: 'number',
            },
            {
                accessor: 'review',
                title: i18n.t('reviews.REVIEW_DELIVERY_RATING_FEEDBACK'),
                width: 200,
                canHideColumn: true,
                component: (amount, item) => renderTextComponent(item.review),
                type: 'number',
            },
            {
                // What the complaint classifier read in the review and the staff notes, by category
                accessor: 'complaintCategory',
                title: i18n.t('reviews.REVIEW_COMPLAINT'),
                width: 220,
                search: true,
                canHideColumn: true,
                type: 'lookup',
                lookupOptions: getComplaintCategoryOptions,
                component: (_, item) => renderTextComponent(getComplaintCategoryTitles(item.complaint_codes).join(", "), 30),
            },
            {
                accessor: 'depotId',
                title: i18n.t('orders.tableColumns.DEPOT'),
                search: true,
                width: 205,
                canHideColumn: true,
                enableSortColumn: true,
                type: 'lookup',
                maxLookupQuantity: 10,
                hideSelectAll: true,
                lookupOptions: () => getDepots(false).map(d => ({ value: d.name, key: d.id })),
                component: (_, item) => {
                    return renderTextComponent(getDepotNameById(item?.depot_id));
                },
            },
        ],
        isForceUpdate: true,
        customTableConfig: {
            key: 'customerServiceReview',
            factoryMap: filterCustomerOrdersTypes,
            mainDateKey: 'creationDateTime',
            summaryComponent: SummaryCustomerReviewFilter,
            filterType: GLOBAL_FILTER_TYPE.reviews,
            loadDataAction: LOAD_HISTORY_CUSTOMERS_REVIEWS_PAGE,
            defaultSort: [{ field: "creationDateTime", direction: -1 }],
            defaultFilters: {
                rating: { operator: "is", type: "lookup", value: getRatingList(), value2: "" },
                deliveryRating: { operator: "is", type: "lookup", value: getRatingList(), value2: "" },
            },
            pinnablePopup: true,
            hideDefaultCloseIcon: true,
            popupComponent: (props) => <CustromerServiceOrders {...props} />,
            reportComponent: () => <ExportFileControl
                control={{ reportType: ReportType.ConsumerReviews, action: CUSTOMER_REVIEWS_GET_REPORT }}
                portalClassName={"exportControlCustomerServicePortal"}
            />,
        },
        typeAction: TYPE_ACTION.edit,
        customSettings: 'adminOrderFixed',
        initNewItemModel: () => ({}),
        typeModel: CUSTOMER_SERVICE_MODEL.reviews,
        isHideControls: true,
        mappingLambda: state => ({}),
    });
}

const ReportCustomerComponent = () => {
    const [isOpenForm, setIsOpenForm] = useState(false);
    return (
        <ExportFileControl
            FilterForm={ReportModalDateRange}
            filterFormProps={{
                isOpen: isOpenForm,
                setIsOpen: setIsOpenForm,
            }}
            canSavePdfReport
            portalClassName={"exportControlCustomerServicePortal"}
            control={{ reportType: ReportType.Consumers, action: CUSTOMERS_GET_REPORT, pdfReportType: ReportType.MarketplaceConsumerEngagement, actionFn: () => setIsOpenForm(true) }}
        />
    )
}

export function createCustomerServiceCustomersSection() {
    return new SectionModel({
        filterOptions: createConsumersSectionFilter(),
        columns: [
            {
                accessor: 'lastOrderDate',
                title: i18n.t('customers.LAST_ORDER_DATE'),
                search: true,
                enableSortColumn: true,
                width: 205,
                component: (_, item) => isDefaultDate(item?.LastOrderDate) ? '' : getFormattedDate(item?.LastOrderDate, DATE_TIME_FORMAT),
                canHideColumn: true,
                type: 'date',
            },
            {
                accessor: 'creationDateTime',
                title: i18n.t('customers.CREATION_DATE'),
                search: true,
                enableSortColumn: true,
                width: 205,
                component: (_, item) => isDefaultDate(item?.CreationDateTime) ? '' : getFormattedDate(item?.CreationDateTime, DATE_TIME_FORMAT),
                canHideColumn: true,
                type: 'date',
            },
            {
                accessor: 'firstOrderDate',
                title: i18n.t('customers.FIRST_ORDER'),
                search: true,
                enableSortColumn: true,
                width: 205,
                component: (_, item) => isDefaultDate(item?.FirstOrderDate) ? '' : getFormattedDate(item?.FirstOrderDate, DATE_TIME_FORMAT),
                canHideColumn: true,
                type: 'date',
            },
            {
                accessor: 'birthdate',
                title: i18n.t('customers.BIRTHDATE'),
                search: true,
                enableSortColumn: true,
                width: 205,
                component: (_, item) => isDefaultDate(item?.Birthdate) ? '' : getFormattedDate(item?.Birthdate, DATE_TIME_FORMAT),
                canHideColumn: true,
                type: 'date',
            },
            {
                accessor: 'lastDepotId',
                title: i18n.t('orders.tableColumns.DEPOT'),
                search: true,
                width: 205,
                canHideColumn: true,
                enableSortColumn: true,
                type: 'lookup',
                maxLookupQuantity: 10,
                hideSelectAll: true,
                lookupOptions: () => getDepots(false).map(d => ({ value: d.name, key: d.id })),
                component: (_, item) => {
                    return renderTextComponent(getDepotNameById(item?.depot_id));
                },
            },
            {
                accessor: 'phone',
                title: i18n.t('customers.PHONE_LABEL'),
                width: 160,
                search: true,
                canHideColumn: true,
                type: 'string',
                filterPlaceholder: i18n.t('orders.CENTER_PHONE_FILTER_LABEL'),
                component: (_, item) => renderTextComponent(item?.Phone, 15),
            },
            {
                accessor: 'email',
                title: i18n.t('customers.EMAIL_LABEL'),
                width: 200,
                search: true,
                canHideColumn: true,
                type: 'string',
                component: (_, item) => renderTextComponent(item?.Email),
            },
            {
                accessor: 'firstName',
                title: i18n.t('edit-customer-order.aboutClient.FIRST_NAME'),
                width: 200,
                search: true,
                canHideColumn: true,
                type: 'string',
                component: (_, item) => renderTextComponent(item?.FirstName),
            },
            {
                accessor: 'lastName',
                title: i18n.t('edit-customer-order.aboutClient.LAST_NAME'),
                width: 200,
                search: true,
                canHideColumn: true,
                type: 'string',
                component: (_, item) => renderTextComponent(item?.LastName),
            },
            {
                accessor: 'loyaltyLevel',
                title: i18n.t('settings.loyaltyCashback.LOYALTY_LEVEL'),
                width: 250,
                canHideColumn: true,
                search: true,
                type: 'lookup',
                lookupOptions: () => loyaltyLevels(),
                component: (value, item) => getLoyaltyLevel(item.LoyaltyLevel, true),
            },
            {
                accessor: 'totalOrders',
                title: i18n.t('edit-customer-order.TOTAL_ORDERS'),
                width: 200,
                search: true,
                canHideColumn: true,
                component: (amount, item) => item.TotalOrders,
                type: 'number',
            },
            {
                accessor: 'totalAmountSpent',
                title: i18n.t('customers.TOTAL_AMOUNT_SPENT'),
                width: 200,
                search: true,
                canHideColumn: true,
                component: (amount, item) => item.TotalAmountSpent,
                type: 'number',
            },
            {
                accessor: 'averageOrderAmount',
                title: i18n.t('customers.AVERAGE_ORDER_AMOUNT'),
                width: 200,
                search: true,
                canHideColumn: true,
                component: (amount, item) => item.AverageOrderAmount,
                type: 'number',
            },
            {
                accessor: 'registrationSources',
                title: i18n.t('customers.REG_THROUGH_LABEL'),
                width: 200,
                canHideColumn: true,
                component: (amount, item) => renderTextComponent(item.RegistrationSources.join(', ') || '-'),
                type: 'string',
            },
            {
                accessor: 'id',
                title: i18n.t('orders.tableColumns.CONSUMER_ID'),
                keyFromSearch: 'userId',
                alwaysHidden: true,
                visible: false,
                canHideColumn: true,
                component: (amount, item) => amount,
                width: 200,
                type: 'string',
                formatForPreview: (items, filter) => {
                    const user = (items || []).find(order => order.ConsumerId === filter.value);
                    return {
                        columnTitle: user ? `${user.FirstName} ${user.LastName}`.trim() : null,
                        operator: null,
                        value: null,
                    }
                },
            },
        ],
        isForceUpdate: true,
        customTableConfig: {
            hideDatePredefinedValue: true,
            reportComponent: ReportCustomerComponent,
            key: 'customerServiceCustomers',
            factoryMap: filterCustomerCustomersTypes,
            defaultSort: [{ field: "lastOrderDate", direction: -1 }],
            summaryComponent: SummaryCustomerCustomersFilter,
            addComponent: AddCustomerButton,
            filterType: GLOBAL_FILTER_TYPE.customers,
            loadDataAction: LOAD_HISTORY_CUSTOMERS_CUSTOMERS_PAGE,
            popupComponent: OrdersPageWrapper,
            hideDefaultCloseIcon: true,
            pinnablePopup: true,
        },
        typeAction: TYPE_ACTION.edit,
        customSettings: 'adminOrderFixed',
        initNewItemModel: () => ({}),
        typeModel: CUSTOMER_SERVICE_MODEL.customers,
        isHideControls: true,
        key: "ConsumerId",
        mappingLambda: state => ({}),
    });
}

export function createCustomerServiceSalesSection() {
    return new SectionModel({
        columns: [
            {
                component: function () {
                    return <CustomerSales />;
                },
            },
        ],
        typeAction: TYPE_ACTION.edit,
        customSettings: 'adminOrderFixed',
        initNewItemModel: () => ({}),
        typeModel: CUSTOMER_SERVICE_MODEL.sales,
        isHideControls: true,
        mappingLambda: state => ({}),
    });
}

export function createCustomerServiceSupportChatSection() {
    return new SectionModel({
        columns: [
            {
                component: function () {
                    return <CustomerServiceChat />;
                },
            },
        ],
        typeAction: TYPE_ACTION.edit,
        customSettings: 'adminOrderFixed',
        initNewItemModel: () => ({}),
        typeModel: CUSTOMER_SERVICE_MODEL.sales,
        isHideControls: true,
        mappingLambda: state => ({}),
    });
}

function createOrdersSectionFilter() {
    let filterOptionsModel = new FilterOptionsModel();

    //search
    filterOptionsModel.addOptions("search", CONTROL_TYPE.text, null, function (order) {
        return groupBarOrderFilter(this.selected, order);
    });

    //date
    let filterDate = filterOptionsModel.addOptions(
        "date",
        CONTROL_TYPE.date,
        i18n.t("dashboard.orders.ORDER_DATE_FILTER_LABEL"),
        function (order) {
            const orderDate = moment.utc(order.date);
            const selectedDate = moment.utc(setStartTime(this.selected));
            return selectedDate <= orderDate;
        },
        null,
        null,
        true,
        false,
        false,
        false,
        {
            format: DATE_FORMAT,
        }
    );
    filterDate.filterType = FILTER_TYPE.and;
    let filterDateEnd = filterOptionsModel.addOptions(
        "dateEnd",
        CONTROL_TYPE.date,
        i18n.t("dashboard.orders.ORDER_DATE_FILTER_LABEL"),
        function (order) {
            const orderDate = moment.utc(order.date);
            const selectedDate = moment.utc(setEndTime(this.selected));
            return orderDate <= selectedDate;
        },
        null,
        null,
        true,
        false,
        false,
        false,
        {
            format: DATE_FORMAT,
        }
    );
    filterDateEnd.filterType = FILTER_TYPE.and;

    return filterOptionsModel;
}

function createConsumersSectionFilter() {
    let filterOptionsModel = new FilterOptionsModel();

    //date
    let filterDate = filterOptionsModel.addOptions(
        "date",
        CONTROL_TYPE.date,
        i18n.t("dashboard.orders.ORDER_DATE_FILTER_LABEL"),
        function (order) {
            const orderDate = moment.utc(order.date);
            const selectedDate = moment.utc(setStartTime(this.selected));
            return selectedDate <= orderDate;
        },
        null,
        null,
        true,
        false,
        false,
        false,
        {
            format: DATE_FORMAT,
        }
    );
    filterDate.filterType = FILTER_TYPE.and;
    let filterDateEnd = filterOptionsModel.addOptions(
        "dateEnd",
        CONTROL_TYPE.date,
        i18n.t("dashboard.orders.ORDER_DATE_FILTER_LABEL"),
        function (order) {
            const orderDate = moment.utc(order.date);
            const selectedDate = moment.utc(setEndTime(this.selected));
            return orderDate <= selectedDate;
        },
        null,
        null,
        true,
        false,
        false,
        false,
        {
            format: DATE_FORMAT,
        }
    );
    filterDateEnd.filterType = FILTER_TYPE.and;

    return filterOptionsModel;
}

export function createCustomerServiceUnfinisedCartSection() {
    const lang = getCurrentLanguage();

    return new SectionModel({
        filterOptions: createOrdersSectionFilter(),
        columns: [
            {
                accessor: 'createdDate',
                title: i18n.t('orders.tableColumns.DATE'),
                search: true,
                enableSortColumn: true,
                width: 205,
                component: (_, item) => isDefaultDate(item.created_date) ? '' : getFormattedDate(item.created_date, DATE_TIME_FORMAT),
                canHideColumn: true,
                shortFilter: true,
                type: 'date',
            },
            {
                accessor: 'updatedDate',
                title: i18n.t('admin-orders.UNFINISHED_CART_UPDATED_DATE'),
                search: true,
                enableSortColumn: true,
                width: 205,
                component: (_, item) => isDefaultDate(item.updated_date) ? '' : getFormattedDate(item.updated_date, DATE_TIME_FORMAT),
                canHideColumn: true,
                alwaysOnFilter: true,
                hideFilterFromPreview: true,
                shortFilter: true,
                type: 'date',
            },
            {
                accessor: 'deliveryType',
                title: i18n.t('orders.tableColumns.TYPE'),
                width: 200,
                search: true,
                type: 'lookup',
                lookupOptions: () => deliveryTypes().concat({ key: DELIVERY_TYPE.virtualVenue, value: i18n.t('dashboard.orders.VIRTUAL_VENUE_ORDERS_MODE_LABEL') }),
                component: (_, item) => {
                    const icons = {
                        [DELIVERY_TYPE.dinein]: 'dinein',
                        [DELIVERY_TYPE.delivery]: 'carbonScooter',
                        [DELIVERY_TYPE.takeAway]: 'carbonTakeaway',
                        [DELIVERY_TYPE.virtualVenue]: 'virtualVenueGift',
                    }
                    const typeIcon = icons[item.delivery_type];
                    return <IconButton isIcon iconName={typeIcon} />;
                },
                canHideColumn: true,
            },
            {
                accessor: 'deliveryStrategy',
                title: i18n.t('orders.tableColumns.DELIVERY_STRATEGY'),
                width: lang === 'ru' ? 250 : 215,
                canHideColumn: true,
                search: true,
                type: 'lookup',
                lookupOptions: () => [
                    { key: DELIVERY_STRATEGY.asap, value: i18n.t('enums.accountOrderDeliveryStrategy.ASAP') },
                    { key: DELIVERY_STRATEGY.concreteTime, value: i18n.t('enums.accountOrderDeliveryStrategy.CONCRETETIME') },
                ],
                component: (value, item) => getAccountOrderDeliveryStrategyList(item.delivery_strategy),
            },
            {
                accessor: 'registeredUser',
                title: i18n.t('admin-orders.UNFINISHED_CART_HAS_CONSUMER'),
                width: lang === 'ru' ? 250 : 215,
                canHideColumn: true,
                search: true,
                type: 'lookup',
                lookupOptions: () => [
                    { key: 1, value: i18n.t('basic.YES_BUTTON') },
                    { key: 0, value: i18n.t('basic.NO_BUTTON') },
                ],
                component: (value, item) => item.customer_id ? i18n.t('basic.YES_BUTTON') : i18n.t('basic.NO_BUTTON'),
            },
            {
                accessor: 'paymentFailure',
                title: i18n.t('admin-orders.UNFINISHED_CART_PAYMENT_FAILURE'),
                width: lang === 'ru' ? 250 : 215,
                canHideColumn: true,
                search: true,
                type: 'lookup',
                lookupOptions: () => [
                    { key: 1, value: i18n.t('basic.YES_BUTTON') },
                    { key: 0, value: i18n.t('basic.NO_BUTTON') },
                ],
                component: (value, item) => item.payment_failure ? i18n.t('basic.YES_BUTTON') : i18n.t('basic.NO_BUTTON'),
            },
            {
                accessor: 'business_id',
                title: i18n.t('admin-orders.RESTAURANT_NAME_LABEL'),
                search: false,
                width: 205,
                canHideColumn: true,
                enableSortColumn: false,
                type: 'lookup',
                maxLookupQuantity: 10,
                hideSelectAll: true,
                lookupOptions: () => getDepots(false).map(d => ({ value: d.name, key: d.id })),
                component: (_, item) => {
                    return renderTextComponent(getDepotNameByBusinessId(item?.business_id));
                },
            },
            {
                accessor: 'city',
                title: i18n.t('orders.tableColumns.ADDRESS_CITY'),
                width: lang === 'ru' ? 160 : 150,
                search: true,
                canHideColumn: true,
                filterPlaceholder: i18n.t('orders.CENTER_PHONE_FILTER_LABEL'),
                type: 'string',
                component: (_, item) => renderTextComponent(item?.city, 15),
            },
            {
                accessor: 'coupon',
                title: i18n.t('uilib.summary.COUPON'),
                width: lang === 'ru' ? 160 : 150,
                search: true,
                filterPlaceholder: i18n.t('orders.CENTER_PHONE_FILTER_LABEL'),
                canHideColumn: true,
                type: 'string',
                component: (_, item) => renderTextComponent(item?.coupon, 15),
            },
            {
                accessor: 'orderChannel',
                title: i18n.t('admin-orders.ORDER_CHANNEL'),
                width: 200,
                search: true,
                type: 'lookup',
                lookupOptions: () => getOrderChannelNames(),
                component: (_, item) => renderTextComponent(orderChannelNames()[item.order_channel]),
                canHideColumn: true,
            },
            {
                accessor: 'driverTip',
                title: i18n.t('edit-customer-order.COURIER_TIP'),
                width: 150,
                search: true,
                canHideColumn: true,
                type: 'number',
                filterPlaceholder: i18n.t('admin-orders.ORDER_INFO_NUMBER_LABEL'),
                component: (_, item) => renderTextComponent((item?.driver_tip || 0).toString()),
            },
            {
                accessor: 'finalChargePrice',
                title: i18n.t('admin-orders.UNFINISHED_CART_FINAL_CHARGE_PRICE'),
                width: 150,
                search: true,
                canHideColumn: true,
                type: 'number',
                filterPlaceholder: i18n.t('admin-orders.ORDER_INFO_NUMBER_LABEL'),
                component: (_, item) => renderTextComponent(item?.final_charge_price),
            },
        ],
        isForceUpdate: true,
        customTableConfig: {
            key: 'unfinishedCart',
            factoryMap: filterUnfinishedCartTypes,
            mainDateKey: 'updatedDate',
            summaryComponent: SummaryUnfinishedCartFilter,
            filterType: GLOBAL_FILTER_TYPE.unfinishedCart,
            loadDataAction: LOAD_UNFINISHED_CART_PAGE,
            popupComponent: (props) => <UnfinishedCartPreview closeIcon {...props} />,
            hideDefaultCloseIcon: false,
            closeButtonInChild: true,
            pinnablePopup: true,
        },
        typeAction: TYPE_ACTION.edit,
        customSettings: 'adminOrderFixed',
        initNewItemModel: () => ({}),
        typeModel: CUSTOMER_SERVICE_MODEL.unfinishedCart,
        isHideControls: true,
        mappingLambda: state => ({}),
    });
}